// extracted by mini-css-extract-plugin
export var addToCartButton = "_oc-b";
export var arrowButtonContainer = "_oc-9";
export var arrowButtonIcon = "_oc-a";
export var carouselArrowButton = "_oc-6";
export var carouselElementContainer = "_oc-1";
export var galleryThumbnail = "_oc-d";
export var galleryThumbnailImage = "_oc-e";
export var left = "_oc-7";
export var productDisplayCarouselContainer = "_oc-0";
export var productTileContainer = "_oc-2";
export var productTileImage = "_oc-4";
export var productTileImageContainer = "_oc-3";
export var productTileTitle = "_oc-5";
export var right = "_oc-8";
export var sliderOverflow = "_oc-c";